__turbopack_context__.v({
  "author-container": "Author-module-scss-module__Z91UjG__author-container",
  "avatar": "Author-module-scss-module__Z91UjG__avatar",
  "date": "Author-module-scss-module__Z91UjG__date",
});
